import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {
    Popover,
    CardHeader,
    Divider,
    colors,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from '@mui/material';
import InputIcon from '@mui/icons-material/Input';
import GroupIcon from '@mui/icons-material/Group';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import { useDispatch, useSelector } from 'react-redux';
import { logoutAdmin } from 'actions/admin/authenticationActions';
import { reverseUserRoute } from 'routes';

const useStyles = makeStyles(() => ({
    root: {
        width: 200,
        maxWidth: '100%'
    },
    actions: {
        backgroundColor: colors.grey[50],
        justifyContent: 'center'
    }
}));

const ProfilePopover = props => {
    const classes = useStyles();
    const { notifications, anchorEl, disabled, ...rest } = props;

    const dispatch = useDispatch();
    const { currentAdmin } = useSelector(state => state.adminAuthReducer);

    const handleLogout = async () => {
        try {
            await dispatch(logoutAdmin(currentAdmin.id))
        } catch (e) {
        }

    };

    return (
        <Popover
            {...rest}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
        >
            <div className={classes.root} onClick={props.onClose}>
                <CardHeader title="Account" />
                <Divider />
                <List component='div' aria-label='profile tab'>

                    {/* See Profile */}
                    <RouterLink to={reverseUserRoute('Profile')}>
                        <ListItem button>
                            <ListItemIcon>
                                <SentimentSatisfiedIcon />
                            </ListItemIcon>
                            <ListItemText primary={<Typography>My Profile</Typography>} />
                        </ListItem>
                    </RouterLink>

                    {/* Manage Team */}
                    <RouterLink to={disabled ? "#" : reverseUserRoute('OrganisationSettings')}>
                        <ListItem button disabled={disabled}>
                            <ListItemIcon>
                                <GroupIcon />
                            </ListItemIcon>
                            <ListItemText primary={<Typography>Manage Team</Typography>} />
                        </ListItem>
                    </RouterLink>

                    {/* Log Out */}
                    <ListItem button onClick={handleLogout}>
                        <ListItemIcon>
                            <InputIcon />
                        </ListItemIcon>
                        <ListItemText primary="Log Out" />
                    </ListItem>
                </List>


            </div>
        </Popover>
    );
};

ProfilePopover.propTypes = {
    anchorEl: PropTypes.any,
    className: PropTypes.string,
    notifications: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};

export default ProfilePopover;
